import { FormControl, InputLabel, OutlinedInput } from "@mui/material";
import { forwardRef, useMemo } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { IMaskInput } from "react-imask";

import dayjs from "dayjs";
import { fieldValueToString } from "../../../../../../common/utils/react_hook_form_input_utils";

/**
 * FormExperienciaInputBase
 */

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const FormExperienciaInputBase = forwardRef<HTMLInputElement, CustomProps>((props, refs) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      placeholderChar="_"
      inputRef={refs}
      onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
      lazy={false}
      overwrite={true}
      unmask={true}
    />
  );
});

/**
 * FormExperienciaInput
 */

type Props = {
  name: string,
  label: string,
  reactHookForm: UseFormReturn<any>,
};

export const FormExperienciaInput = ({
  name,
  label,
  reactHookForm,
}: Props) => {
  const watchs = reactHookForm.watch(['dataAdmissao', 'experiencia']);

  const dataAdmissao = watchs[0] as Date;
  const experiencia = watchs[1] as string;

  const computedDate = useMemo(() => {
    if (!dataAdmissao) return null;
    if (!experiencia || experiencia.length <= 0) return null;
    return dayjs(dataAdmissao).add(parseInt(experiencia) - 1, 'day').format('DD/MM/YYYY');
  }, [dataAdmissao, experiencia]);

  return (
    <Controller
      name={name}
      control={reactHookForm.control}
      render={({ field, formState }) => (
        <FormControl variant="outlined" size="small">
          <InputLabel htmlFor={`input-${name}`} shrink={true} size="small">{label}</InputLabel>
          <OutlinedInput
            size="small"
            id={`input-${name}`}
            name={name}
            value={fieldValueToString(field.value)}
            label={label}
            notched={true}
            onChange={field.onChange}
            disabled={formState.disabled}
            inputComponent={FormExperienciaInputBase as any}
            inputProps={{
              mask: '000',
              placeholder: '___',
            }} />
          <p className="text-blue-600 ms-2 mt-1">{computedDate}</p>
        </FormControl>
      )} />
  );
}